//#region imports
import React, {useEffect, useState} from 'react';

// custom components
import { Text, Button, Footer } from '../../components/atoms/';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';

// images
import BookingCard from '../../assets/images/home/booking-card.png';
import Calendar from '../../assets/images/home/calendar.png';
import CustomerSupport from '../../assets/images/home/customer-support.png';
import ConnectLogo from '../../assets/images/home/prm-connect-logo.png';

// icons
import { IoMdArrowRoundForward } from 'react-icons/io';

// styling
import { Mixins } from '../../styles/index';

//#endregion

//#region components

// card in learn more about prm assist section
const LearnMoreCard = (props) => {
    return (
        <Nav.Link href={props.link} style={{ cursor:'pointer' }}>
            <img
                src={props.image ? props.image : Calendar}
                width='90px'
                alt=""
            />
            <Text.Header color={'#307FE2'} className='mt-2'>{props.title}</Text.Header>
            <Text.Subheader containerStyle={{marginTop:-8}}>{props.subtitle}</Text.Subheader>
        </Nav.Link>
    )
}
//#endregion

const Home = (props) => {

    const border = false; 

    const [windowWidth, setWindowWidth] = useState(2000)

    return (
        <>
            <Row fluid style={{borderStyle: border && 'solid', borderWidth: border && 1}} >
                
                {/* Title & Subtitle */}
                <Row>
                    <Container className='mt-5' style={{borderWidth:border && 1, borderStyle: border && 'solid'}}>
                        <Text.Title>PRM Documentation</Text.Title>
                        <Text.Subtitle>PRM Connect API</Text.Subtitle>
                        <Text.Text>Explore our guide and examples to integrate with PRM Connect's API.</Text.Text>
                    </Container>
                </Row>
                
                {/* Text, Buttons and Booking Card Image */}
                <Row>

                    {/* Text and Buttons */}
                    <Col style={{borderStyle: border && 'solid', borderWidth: border && 1}}>
                        <Container className='mt-5' style={{borderWidth: border && 1, borderStyle: border && 'solid'}}>
                            
                            {/* Title and Subtitle */}
                            <Text.Heading>PRM Bookings</Text.Heading>
                            <Text.Text>Our brand new API allows airports and service providers access to airline PRM Assistance bookings, months in advance of passenger departures. Our solution improves operational efficency and staff management, ensuring the airport service provider is equipped to manage passenger volume.</Text.Text>

                            {/* Get started button */}
                            <div className='mt-4'>
                            <Button.CustomButton 
                                link={'/getting-started'} 
                                variant={'outline-primary'} 
                                icon={<IoMdArrowRoundForward size={16} color={'#307FE2'} style={{marginLeft:6, marginTop:-2}} />}
                            >
                                Get Started
                            </Button.CustomButton>
                            </div>
                                
                        </Container>
                    </Col>
                        
                    {/* image */}    
                    <Col style={{borderStyle: border && 'solid', borderWidth: border && 1, borderColor:'red', marginTop:100}} >
                        <img
                            src={BookingCard}
                            width={
                                Mixins.WINDOW_WIDTH < 1130 ?
                                '250px'
                                :
                                '450px'
                            }
                            alt=""
                        />
                    </Col>
                </Row>

                {/* Learn about PRM Connect */}
                <Row>
                    <Col xs={11} className='mt-5'>
                        <Container>
                        <Text.Heading>Learn about PRM Connect</Text.Heading>
                        
                        <Row className='mt-4'>
                            <Col>
                                <LearnMoreCard
                                    title={'How the solution works'}
                                    subtitle={'Learn how the PRM Connect API works and how it can help you.'}
                                    link={'introduction'}
                                    image={ConnectLogo}
                                />
                            </Col>
                            <Col>
                                <LearnMoreCard 
                                    title={'Getting Started'}
                                    subtitle={'Learn how to intergrate with PRM Connect.'}
                                    link={'getting-started'}
                                    image={Calendar}
                                />
                            </Col>
                            <Col>
                                <LearnMoreCard 
                                    title={'Contact'}
                                    subtitle={'Reach out and talk with our dedicated team of experts.'}
                                    link={'https://prmassist.com/contact'}
                                    image={CustomerSupport}
                                />
                            </Col>
                        </Row>
                        </Container>
                    </Col>
                </Row>
            </Row>

            {/* Footer */}
            <Footer />
        </>
    );
};

export default Home;
